<template>
  <transition name="cg-message-fade" @after-leave="handleAfterLeave">
    <div
      v-show="show"
      :class="[
        'cg-message',
        `cg-message__${type}`,
        center ? 'cg-message——center' : '',
        customClass,
      ]"
      :style="{ top: verticalOffset + 'px' }"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <i class="iconfont icon-icon_left" />
      <i :class="['iconfont', `icon-${type}`, 'cg-icon']" />
      <p v-if="dangerouslyUseHTMLString" class="cg-message__content" v-html="message" />
      <p else class="cg-message__content">{{ message }}</p>
      <i v-show="showClose" class="iconfont icon-close" @click="close" />
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: true,
      dangerouslyUseHTMLString: false, // 是否为富文本
      message: '', // 内容
      verticalOffset: 100,
      duration: 3000, // 弹窗停留市场 单位ms毫秒 | 如果是0, 不会自动关闭
      type: 'info', // 弹窗类型 [ 'success', 'warning', 'info', 'error' ]
      customClass: '', // 定制类名
      onClose: null, // 关闭回调
      timer: null, // 定时器
      showClose: false, // 是否显示关闭按钮
      center: false // 是否居中
    }
  },
  mounted() {
    this.startTimer()
    document.addEventListener('keydown', this.keydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown)
  },
  methods: {
    close() {
      this.show = false
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
    },
    // 渐变离开结束后 回调
    handleAfterLeave() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    // 开始定时器
    startTimer() {
      if (this.duration !== 0) {
        setTimeout(() => {
          this.close()
        }, this.duration)
      }
    },
    // 清楚定时器
    clearTimer() {
      clearTimeout(this.timer)
    },
    // esc关闭消息
    keydown(e) {
      if (e.keyCode === 27) {
        this.show = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .cg-message {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    padding: 14px 14px 14px 34px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    overflow: hidden;
    min-width: 300px;
    max-width: 450px;
    font-size: 16px;
    line-height: 24px;
    transition: all 0.4s;
    border: 1px solid #dadee7;
    z-index: 9999;
    .icon-icon_left {
      position: absolute;
      left: -9px;
      top: 12px;
      font-size: 50px;
      opacity: 0.15;
    }
    .cg-message__content {
      min-width: 200px;
      max-width: 350px;
    }
    .cg-icon {
      margin-right: 14px;
      font-size: 20px;
      align-self: flex-start;
    }
    .icon-close {
      cursor: pointer;
    }
  }
  .cg-message——center {
    justify-content: center;
  }
  .cg-message__success {
    color: #51992e;
    background-color: #f0f9eb;
    border-color: #b8e2a3;
  }
  .cg-message__warning {
    color: #cc9035;
    background-color: #fdf6ec;
    border-color: #f8e4c8;
  }
  .cg-message__info {
    color: #787b80;
    background-color: #edf2fc;
  }
  .cg-message__error {
    color: #e67373;
    border-color: #FCD5D5;
    background-color: #FEF0F0;
  }
  /**
    渐变动画
  */
  .cg-message-fade-enter,
  .cg-message-fade-leave-active {
    opacity: 0;
    -webkit-transform: translate(-50%, -100%);
    transform: translate(-50%, -100%);
  }
</style>
